<template>
  <!-- 智慧社区-->
  <div class="scheme_container">
    <div class="scheme_wrap">
      <div class="title_wrap">{{pageData.title}}</div>
      <div class="content_wrap">
        <div class="article_box unify_article">{{pageData.text.text1}}</div>
        &nbsp;
        <div class="img_wrap" v-for="( item, index ) in pageData.imgArr" :key="`${index}-img`">
          <img :src="item.imgSrc" alt="" />
        </div>
        &nbsp;
        <div class="article_wrap" v-for="( item, index ) in pageData.text.textArr" :key="index">
          <div class="subtitle">{{item.textTitle}}</div>
          <div class="text unify_article" v-for="(itemText, indexText) in item.textContent" :key="`${index}-${indexText}`">
            {{itemText}}
          </div>
          &nbsp;
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        pageData: {
          title: "智慧社区",
          text: {
            text1: "瑞谦智慧社区解决方案以“互联网+”为基础，社区服务、智能家居为核心，围绕社区安全、生活娱乐、物业管理、医疗养老等需求，借助物联网、人工智能、大数据等新技术，把物业服务、安防管理、社区民生服务等集成在一个社区运营平台，打造一个统一服务入口建设“绿色、安全、舒适、便捷”的智慧社区，提高物业管理水平，提升业主生活品质。",
            textArr: [
              {
                textTitle: "生活娱乐",
                textContent: [
                  "建设与智慧社区联动的智能家居，一键场景设置、一屏掌控家庭所有灯光、电器设备，提高居民生活幸福感；",
                  "无人货柜、共享图书室、智能垃圾分类回收箱等智能产品的应用，使社区居民生活更便捷、舒适。"
                ],
              },
              {
                textTitle: "物业管理",
                textContent: [
                  "建设社区管理综合统一平台，集成停车场管理、视频监控、门禁系统、电梯管理、智能巡更等物业管理系统，实现社区各独立应用子系统的融合，形成物业管理智能化。"
                ]
              },
              {
                textTitle: "医疗养老",
                textContent: [
                  "建设智慧社区健康管理平台，通过智能家居健康、安全设备的数据互联及同步，实现社区居民与医护人员、服务机构的信息交互，为居民和周边医疗机构、养老服务机构之间搭建起沟通、互联、合作的桥梁，开展“医、养”一体化服务。"
                ]
              },
              {
                textTitle: "校园安全",
                textContent: [
                  "以人脸识别技术为基础，结合视频监控系统、周界安防系统等，构建具有丰富的报警联动功能的智慧安防，全方面对校园安全进行实时监控和预防，极大减少校园安全事故，提升学校的安全管理水平。"
                ]
              }
            ],
          },
          imgArr: [
            {
              imgSrc: require("@/assets/img/solution/pageImg/3.png"),
              alt: ""
            }
          ]
        }
      }
    }

  }
</script>

<style scoped lang="scss">
@import "@/views/solution/unifyStyle";
</style>
